import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const Spinner = ({
  asOverlay = false,
  size = 'medium',
  color = 'primary',
  text = '',
}) => {
  // Convert size string to number for MUI
  const sizeMap = {
    small: 24,
    medium: 40,
    large: 56,
  };

  const spinnerSize = sizeMap[size] || sizeMap.medium;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...(asOverlay && {
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(255, 255, 255, 0.7)',
          zIndex: 1000,
        }),
      }}
    >
      <div className='flex flex-col  items-center gap-4'>
        <CircularProgress size={spinnerSize} color={color} />
        {text && <p>{text}</p>}
      </div>
    </Box>
  );
};

export default Spinner;
